import { render, staticRenderFns } from "./Orderitem.vue?vue&type=template&id=09c73b47&scoped=true"
import script from "./Orderitem.vue?vue&type=script&lang=js"
export * from "./Orderitem.vue?vue&type=script&lang=js"
import style0 from "./Orderitem.vue?vue&type=style&index=0&id=09c73b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c73b47",
  null
  
)

export default component.exports